import { useCookieState } from '../../hooks/use-cookie-state'
import { useIsLoggedInQuery } from 'auth/hooks'
import { useUserIsOnHoldSubscriberQuery } from '@repo/cf-user/hooks/use-user-data'
import { useStudioSiteDataQuery } from '@repo/studio-hooks-site-data/use-studio-site-data'

import { resolveOnHoldBannerQuery } from './resolve-on-hold-banner-query'

export function useOnHoldBannerQuery() {
  const isLoggedInQuery = useIsLoggedInQuery()
  const isOnHoldSubscriberQuery = useUserIsOnHoldSubscriberQuery()
  const onHoldBannerQuery = useStudioSiteDataQuery({
    select: data => Boolean(data.siteData.onHoldSubscriptionBanner),
  })
  const cookieState = useCookieState()

  return resolveOnHoldBannerQuery({
    isAuthPending: isLoggedInQuery.isPending,
    isLoggedIn: isLoggedInQuery.data === true,
    isSubscriberFlagPending: isOnHoldSubscriberQuery.isPending,
    isOnHoldSubscriber: isOnHoldSubscriberQuery.data,
    isSiteDataPending: onHoldBannerQuery.isPending,
    hasOnHoldBanner: onHoldBannerQuery.data,
    allAccessStatus: cookieState.allAccessStatus,
    aiStatus: cookieState.aiStatus,
  })
}
